import { CustomError } from '../../common/errors';
import { EmployeeId } from './types';

export class EmployeeNotFoundError extends CustomError {
  constructor(readonly employeeId: EmployeeId) {
    super(
      'EmployeeNotFoundError',
      `Couldn't find employee with id ${employeeId}`
    );
  }
}
